export default __webpack_public_path__ + "static/media/exchangebck.3ec83c71.png";